import { useState } from 'react';
import {
  callRemoveBoardClaim,
  callSetBoardClaim,
  useAdmins,
} from '../lib/admin';
import { useAuth } from '../lib/auth';

export default function AdminAdmins() {
  const { user } = useAuth();
  const { admins, loading } = useAdmins();
  const [email, setEmail] = useState('');
  const [working, setWorking] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function handleAdd(e: React.FormEvent) {
    e.preventDefault();
    if (!email.trim()) return;
    setError(null);
    setWorking(true);
    try {
      await callSetBoardClaim(email.trim());
      setEmail('');
    } catch (err) {
      setError(translateError(err));
    } finally {
      setWorking(false);
    }
  }

  async function handleRemove(addrEmail: string) {
    setError(null);
    setWorking(true);
    try {
      await callRemoveBoardClaim(addrEmail);
    } catch (err) {
      setError(translateError(err));
    } finally {
      setWorking(false);
    }
  }

  return (
    <div className="space-y-4">
      <h1 className="text-xl font-bold">Styrelse-administratörer</h1>
      {error && <p className="text-sm text-red-700">{error}</p>}

      <section>
        <h2 className="font-bold mb-2">Nuvarande</h2>
        {loading ? (
          <p>Laddar…</p>
        ) : (
          <ul className="space-y-2">
            {admins.map((a) => (
              <li
                key={a.id}
                className="flex justify-between items-center border rounded p-2"
              >
                <span>
                  {a.firstName} {a.lastName} — {a.email}
                </span>
                {a.id === user?.uid ? (
                  <span className="text-xs text-gray-600">[Du]</span>
                ) : (
                  <button
                    type="button"
                    disabled={working}
                    onClick={() => void handleRemove(a.email)}
                    className="px-2 py-1 text-sm border border-red-700 text-red-700 rounded"
                  >
                    Ta bort
                  </button>
                )}
              </li>
            ))}
          </ul>
        )}
      </section>

      <form onSubmit={handleAdd} className="space-y-2 border-t pt-4">
        <h2 className="font-bold">Lägg till</h2>
        <label className="block">
          <span className="text-sm">Email</span>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="mt-1 w-full rounded border-gray-300 px-2 py-2"
          />
        </label>
        <button
          type="submit"
          disabled={working || !email.trim()}
          className="px-3 py-2 bg-navy text-white rounded disabled:opacity-50"
        >
          Lägg till
        </button>
      </form>
    </div>
  );
}

function translateError(err: unknown): string {
  const e = err as { code?: string; message?: string };
  if (e.code === 'functions/permission-denied') {
    return 'Du har inte admin-behörighet.';
  }
  if (e.code === 'functions/not-found') {
    return 'Ingen användare med den emailen.';
  }
  if (e.code === 'functions/already-exists') {
    return e.message ?? 'Konflikt.';
  }
  if (e.code === 'functions/unavailable') {
    return 'Försök igen om en stund.';
  }
  return e.message ?? 'Något gick fel.';
}
